<spb-yes-no-input
  (resultAnswer)="form.controls.selected.setValue($event)"
  (resultValue)="form.controls.cost.setValue($event)"
  [ctrl]="form.controls.cost"
  [initialState]="form.controls.selected.value"
  inputLabel="Belopp"
  yesNoLabel="Finns studielån?"
  inputSuffix="kr / mån"
></spb-yes-no-input>